/** Major Saudi cities and municipalities (English names, alphabetical). */
export const SAUDI_CITIES: string[] = [
  'Abha',
  'Al Ahsa (Hofuf)',
  'Al Bahah',
  'Al Jubail',
  'Al Kharj',
  'Al Khobar',
  'Al Lith',
  'Al Majma\'ah',
  'Al Qatif',
  'Al Qunfudhah',
  'Al Ula',
  'Arar',
  'Buraidah',
  'Dammam',
  'Dhahran',
  'Diriyah',
  'Hafar Al-Batin',
  'Hail',
  'Jazan',
  'Jeddah',
  'Khamis Mushait',
  'Mecca',
  'Medina',
  'Najran',
  'Rabigh',
  'Riyadh',
  'Sakaka',
  'Tabuk',
  'Taif',
  'Yanbu',
].sort((a, b) => a.localeCompare(b));
